module.exports = __webpack_public_path__ + "static/Gotham-Black-8faba3db5e37f5f5e3bb9e10cb6a74aa.ttf";